

























































import Vue from 'vue';
import layout from '@/libs/layout/educational/material';
import { Component } from 'vue-property-decorator';
import { TLayout } from '@/types/utils';
import {
  TMaterialPage,
  TMaterialList,
  PMaterialSearch
} from '@/types/views/educational';
import { getMaterial } from '@/api/educational';
declare var window: any;
@Component({})
export default class List extends Vue {
  private query = '';
  private courseInfo: TMaterialList = {};
  private layout: TLayout = layout;
  private page: TMaterialPage = {
    currentPage: 1,
    pageSize: 20
  };
  private searchOption: PMaterialSearch = {
    currentPage: 1,
    size: 20
  };
  private activated () {
    this.getMaterial();
  }
  private async getMaterial() {
    try {
      this.page = await getMaterial(this.searchOption);
    } catch (e) {
      this.$message.error(e.message);
    }
  }
  private handleSize(size: number) {
    this.searchOption = { ...this.searchOption, ...{ size } };
    this.getMaterial();
  }
  private handlePage(page: number) {
    this.searchOption = {
      ...this.searchOption,
      ...{ currentPage: page, size: this.page.pageSize }
    };
    this.getMaterial();
  }
  private renderIndex(index: number) {
    return index + 1 + (this.page.currentPage - 1) * this.page.pageSize || 0;
  }
  private search() {
    this.searchOption = { ...this.searchOption, ...{ name: this.query } };
    this.getMaterial();
  }
  private handleDownload(file: any) {
    if (!file.materialUrl) {
      this.$message.error('下载地址不存在，无法下载');
      return;
    }
    // 动态创建元素
    const iframe = document.createElement('iframe');
    document.body.appendChild(iframe);
    let src = file.materialUrl;
    iframe.setAttribute('id', 'myFrame');
    (window.frames['myFrame'] as any).src = src;

    setTimeout(() => {
      document.body.removeChild(iframe);
    }, 30000);
  }
  private showDialog(row: TMaterialList) {
      console.log(row)
    this.courseInfo = row;
    (this.$refs.dialog as any).dialogVisible = true
  }
}
